import { render, staticRenderFns } from "./CreateCompanyPortfolio.vue?vue&type=template&id=e27d8df6&scoped=true&"
import script from "./CreateCompanyPortfolio.vue?vue&type=script&lang=js&"
export * from "./CreateCompanyPortfolio.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e27d8df6",
  null
  
)

export default component.exports